import { Button } from '@mr-yum/frontend-ui'
import { Text } from 'components/Skeleton/Text'
import times from 'lodash/times'
import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  hasCartSummary: boolean
}

export const CheckoutCTASkeleton = ({ hasCartSummary }: Props) => {
  return (
    <div>
      {hasCartSummary && (
        <div className="mb-3 sm:mb-4">
          <div className="mb-2">
            {times(3, (i) => (
              <div
                key={i}
                className="mb-[2px] flex items-baseline justify-between sm:mb-1"
              >
                <div className="text-current my-body-md">
                  <Text chars={12} />
                </div>

                <div className="text-current my-body-md">
                  <Text chars={3} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <Button type="button" size="lg" isLoading fullWidth>
        <FormattedMessage id="acrOoz" defaultMessage="Continue" />
      </Button>
    </div>
  )
}
